import React from 'react';
import {Link} from 'gatsby';

// sub-footer 各段落一律用全形分隔符，字級與顏色由外層 Copyright 統一提供
export const COPYRIGHT_SEPARATOR = '｜';

const CopyrightLinks = () => {
  return (
    <>
      {COPYRIGHT_SEPARATOR}
      <Link to="/privacy">隱私政策</Link>
      {COPYRIGHT_SEPARATOR}
      <Link to="/terms">服務聲明</Link>
    </>
  );
};

export default CopyrightLinks;
